/**
 * Exporta a XLSX el Reporte de Carga Académica.
 * Soporta tipo ASESOR y ESTUDIANTE.
 */
import * as XLSX from 'xlsx';

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteCargaAcademicaXLS({ resultados = [], tipoReporte = 'ASESOR', contexto = {} } = {}) {
  const isAsesor = tipoReporte === 'ASESOR';

  const {
    ciclo = 'Todos',
    campus = 'Todos',
    seccion = 'Todas',
    asesor = 'Todos',
    estudiante = 'Todos',
    matricula = 'Todas',
  } = contexto;

  const columnas = isAsesor
    ? ['#', 'Asesor', 'Clave de Grupo', 'Materia', 'Turno']
    : ['#', 'Matrícula', 'Estudiante', 'Clave de Grupo', 'Materia', 'Turno'];

  const aoa = [
    ['REPORTE DE CARGA ACADÉMICA'],
    [`Tipo: ${isAsesor ? 'ASESOR' : 'ESTUDIANTE'}`],
    [`Ciclo Escolar: ${ciclo}`],
    [`Campus: ${campus}`],
    [`Sección: ${seccion}`],
    [isAsesor ? `Asesor: ${asesor}` : `Estudiante: ${estudiante}`],
    [isAsesor ? '' : `Matrícula: ${matricula}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [],
    columnas,
  ];

  resultados.forEach((r, index) => {
    const base = [
      index + 1,
      r.clave_grupo || '',
      r.materia || '',
      r.turno || '',
    ];

    if (isAsesor) {
      aoa.push([
        index + 1,
        r.asesor || '',
        base[1],
        base[2],
        base[3],
      ]);
    } else {
      aoa.push([
        index + 1,
        r.matricula || '',
        r.estudiante || '',
        base[1],
        base[2],
        base[3],
      ]);
    }
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = isAsesor
    ? [
        { wch: 6 },
        { wch: 42 },
        { wch: 18 },
        { wch: 40 },
        { wch: 12 },
      ]
    : [
        { wch: 6 },
        { wch: 16 },
        { wch: 42 },
        { wch: 18 },
        { wch: 40 },
        { wch: 12 },
      ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: isAsesor ? 4 : 5 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Carga Academica');

  const fileName = `reporte_carga_academica_${isAsesor ? 'asesor' : 'estudiante'}_${fechaArchivo()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}

export default exportReporteCargaAcademicaXLS;
